"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuggestedPerformers = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Contexts_1 = require("../Contexts");
var PerformerDataSourceContext_1 = require("./PerformerDataSourceContext");
var SearchResultsGridSection_1 = require("./SearchResultsGridSection");
var SearchResultsSectionThumbnails_1 = require("./SearchResultsSectionThumbnails");
var SuggestedPerformers = function (_a) {
    var queryOptionsProp = _a.queryOptions, navigation = _a.navigation, _b = _a.numberOfSuggestions, numberOfSuggestions = _b === void 0 ? 48 : _b, emitTrackingEvent = _a.emitTrackingEvent, openJoinModal = _a.openJoinModal;
    var breakpoint = (0, react_1.useContext)(Contexts_1.ILayoutContext).breakpoint;
    var translate = (0, react_1.useContext)(Contexts_1.ITranslationServiceContext).translate;
    var queryOptions = __assign({ type: "browse" }, queryOptionsProp);
    return ((0, jsx_runtime_1.jsx)(PerformerDataSourceContext_1.PerformerDataSourceContext, { dataOptions: {
            itemRange: { start: 0, end: numberOfSuggestions },
            dataRequestPageSize: numberOfSuggestions,
            genderSetting: "",
            queryOptions: queryOptions,
        }, children: function (dataSource) { return ((0, jsx_runtime_1.jsx)(SearchResultsGridSection_1.SearchResultsGridSection, { onlineOfflineMode: "online", breakpoint: breakpoint, dataSource: dataSource, queryOptions: queryOptions, translate: translate, navigation: navigation, 
            // TODO: Should be a noop function, but leaving as is
            emitTrackingEvent: emitTrackingEvent, isFirstGrid: true, onJoinClicked: function () { }, onLoginClicked: function () { }, 
            // Recently implemented logic here excluding the size of the thumbnail relies on internal logic that falls back to medium.
            // TODO: See if this means the feature isn't actually behaving correctly
            thumbnailSize: SearchResultsSectionThumbnails_1.ThumbnailSize.medium, openJoinModal: openJoinModal })); } }));
};
exports.SuggestedPerformers = SuggestedPerformers;
//# sourceMappingURL=SuggestedPerformers.js.map